"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Event object for
 * @see EventBaseImpl
 * */
var Event = /** @class */ (function () {
    function Event(routingKey, time, data) {
        this.routingKey = routingKey;
        this.time = time;
        this.data = data;
    }
    Event.create = function (routingKey, data) {
        var time = new Date().getTime();
        return new Event(routingKey, time, data);
    };
    return Event;
}());
exports.Event = Event;
//# sourceMappingURL=event.js.map